import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {PharmacyLocationEnum} from '../PharmacyLocationEnum';
import {Select, Store} from '@ngxs/store';
import {AuthState} from '../../../states/auth/auth.state';
import {Observable} from 'rxjs/internal/Observable';
import {IUser} from '../../../interfaces/user.interface';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {PharmacyState} from '../../../states/pharmacy/pharmacy.state';
import {GetPharmacyByNPI, SavePharmacyForm} from '../../../states/pharmacy/pharmacy.actions';
import { ApiMessagesEnum } from 'src/app/shared/interfaces/ApiMessagesEnum';
import { CheckboxRequiredValidator } from 'src/app/shared/validators/checkbox-required.validator';
import { BAATypeEnum } from 'src/app/shared/interfaces/BAATypeEnum';
import { INpiStepData } from 'src/app/shared/interfaces/INpiStepData.interface';
import { highlightRequiredControlsWithErrors } from 'src/app/shared/helpers/helpers';

@UntilDestroy()
@Component({
  selector: 'app-npi-number',
  templateUrl: './npi-number.component.html',
  styleUrls: ['./npi-number.component.scss'],
})
export class NpiNumberComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() location: PharmacyLocationEnum;

  @Output() nextStep: EventEmitter<INpiStepData> = new EventEmitter();
  @Output() cancel: EventEmitter<void> = new EventEmitter();

  PharmacyLocationEnum = PharmacyLocationEnum;
  
  NPIMaxLength = 10;

  npiForm: UntypedFormGroup;

  @Select(AuthState.currentUser) userData$: Observable<IUser>;
  @Select(PharmacyState.pharmacyData) pharmacyData$: Observable<any>;
  @Select(PharmacyState.loading) loading$: Observable<boolean>;

  @ViewChild('npiNumberInput') npiNumberInput;
  @ViewChild('baaAgreementCheckbox') baaAgreementCheckbox;
  @ViewChild('submit') submitBtn;

  baaOptionsList: any[] = [
    {
      id: BAATypeEnum.C2Keep,
      name: 'I agree to be bound by the standard',
      link: ' C2 Keep BAA'
    },
    {
      id: BAATypeEnum.NonC2Keep,
      name: 'I consent to sign a different BAA with C2 Keep',
    },
  ];


  constructor(private store: Store, private fb: UntypedFormBuilder) {
    this.npiForm = this.fb.group({
      npiNumber: [null, [Validators.required]],
      termsConditions: [null, [CheckboxRequiredValidator()]],
      baa: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => this.npiNumberInput.appInput.nativeElement.focus());
  }

  ngOnDestroy(): void {
    // TODO: create new instance for dialog instead
    this.npiForm.reset();
  }

  getPharmacyByNPI(): void {
    if (this.npiForm.invalid) {
      highlightRequiredControlsWithErrors(this.npiForm);
    }
    else {
      this.store.dispatch(
        new GetPharmacyByNPI(this.npiForm.get('npiNumber').value)
      );
      this.subscribeOnGetPharmacyData();
    }
  }

  subscribeOnGetPharmacyData(): void {
    this.pharmacyData$.pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if (
          data.empty &&
          data.messageEnumKey &&
          ApiMessagesEnum[data.messageEnumKey] ===
            ApiMessagesEnum.NpiAlreadyInUse
        ) {
          this.npiForm.get('npiNumber').setErrors({ npiInUse: true });
          this.npiForm.get('npiNumber').markAsTouched();
        } else if (data.empty) {
          this.npiForm.get('npiNumber').setErrors({ invalidNPI: true });
          this.npiForm.get('npiNumber').markAsTouched();
        } else {
          this.store.dispatch(new SavePharmacyForm(null));
          const rawValue = this.npiForm.getRawValue();
          this.nextStep.emit({npi: rawValue.npiNumber, baa: rawValue.baa });
        }
      }
    });
  }

  //These 2 handlers required to handle checkbox TAB key down
  termAndConditionsCheckBoxToggled(checked: boolean): void {
    this.npiForm.get('termsConditions').setValue(checked);
  }

  baaAgreementCheckBoxToggled(checked: boolean): void {
    this.npiForm.get('baa').setValue(checked);
  }

  onEulaClick(event: MouseEvent): void {
    event.preventDefault();
    window.open(
      'https://drive.google.com/file/d/1SEej9KeQ1IdpTiIk4ue-gmxAOrtEpehR/view',
      '_blank'
    );
  }

  onBaaClick(): void {
    event.preventDefault();
    window.open(
      'https://drive.google.com/file/d/1ALOZ4mhBqDSdfwErILglcVYVppoNglp8/view',
      '_blank'
    );
  }

  focusNpi(): void {
    setTimeout(() => {
        this.npiNumberInput?.appInput?.nativeElement?.focus();
    });
  }

  focusBaaCheckbox(): void {
    setTimeout(() => {
      this.baaAgreementCheckbox.checkBox.nativeElement.focus();
    });
  }

  baaAgreementTabKeyDown() {
    this.npiForm.valid
      ? setTimeout(() => this.submitBtn?.appButton.nativeElement.focus()) : 
      this.focusNpi();
  }

  closeNpi(): void {
    this.npiForm.reset();
    this.cancel.emit();
  }
}
